import { FolderNavigation } from "@c/FolderNavigation";
import { GardenNote } from "@c/GardenNote";
import { MainPage } from "@c/MainPage";
import { NoteStore } from "@store/NoteStore";
import { observer } from "mobx-react-lite";
import React from "react";

export const NotePage: React.FC<{ note: NoteStore }> = observer(({ note }) => {
    return (
        <MainPage isEditor>
            <main className="container fullscreen fullheight">
                <div className="columns is-centered fullheight" style={{ alignItems: 'stretch' }}>
                    <FolderNavigation />
                    <div className="column editor-column has-background-white-bis" style={{ maxWidth: '60rem' }}>
                        <GardenNote note={note} />
                    </div>
                </div>
            </main>
        </MainPage>
    );
});